import * as React from 'react';

// @ts-expect-error
import type {FieldArrayProps} from 'redux-form';

import {useGetStagesets} from '../../select/hooks/use-get-stagesets';

import {TriggerLeadFields} from './trigger-lead-fields';

type PipelineFieldsProps = {
    fields: FieldArrayProps['fields'];
    meta: FieldArrayProps['meta'];
    formType: 'stageEntered' | 'leadClosed';
};

export function PipelineFields(props: PipelineFieldsProps): React.ReactElement {
    const {stagesets} = useGetStagesets();

    return stagesets.length ? (
        <TriggerLeadFields {...props} formType={props.formType} optionFields={stagesets} />
    ) : // @ts-expect-error
    null;
}
